import { Component, OnInit, ViewChild } from '@angular/core';
import { Vehicle } from './vehicle';
import { VehicleService } from './vehicle.service';
import { ActivatedRoute } from '@angular/router';
import {Message} from 'primeng/api';
import { VehicleBrandService } from '../vehicle-brand/vehicle-brand.service';
import { VehicleBrand } from '../vehicle-brand/vehicle-brand';
import { Status } from '../status/status';
import { StatusService } from '../status/status.service';

@Component({
    templateUrl: './vehicle.component.html'
})

export class VehicleComponent implements OnInit {

    @ViewChild('myTable') myTable;

    items: Vehicle[] = [];
    item: Vehicle = { id: null, vehicleBrand: null, description: null, status: null };
    outItem: Vehicle;
    selectedItem: Vehicle;
    msgs: Message[] = [];
    statuslist: Status[] = [];
    brandlist:VehicleBrand[];

    constructor(
        private activatedRoute: ActivatedRoute,
        private service: VehicleService,
        private brandService: VehicleBrandService,
        private statusService: StatusService,
        ) { }

    ngOnInit() {
        this.statusService.findAll().subscribe(status => {
            this.statuslist = status.filter(x => x.type == "Master");
        });
        this.brandService.findAll().subscribe( brands => {
            this.brandlist = brands;
        });
        this.activatedRoute.params.subscribe(params => {
            this.items = this.activatedRoute.snapshot.data['items'];
        });
    }

    newItem() {
        this.msgs = [];
        this.selectedItem = { id: null, vehicleBrand: null, description: null, status: null };
        this.items = [this.selectedItem].concat(this.items);
        this.myTable.first = 0;
    }

    delete(item: Vehicle) {
        this.msgs = [];
        if (item.id != null){
           this.service.delete(item).subscribe( (data) => {
            const deletedItem = this.items.find(x => x.id === item.id);
            this.items.splice(this.items.indexOf(deletedItem), 1);
 
            this.msgs.push({
                severity: 'success',
                detail: 'Registro excluído'
            });
           }, (err) => {
            this.msgs.push({
                severity: 'error',
                detail: 'Não é possível excluir o registro'
            });
           });
        }
    }

    save(item: Vehicle) {
        this.msgs = [];

        if (item.vehicleBrand == null) this.msgs.push({severity:'error', detail:'Marca obrigatória'});
        if (item.description == null)  this.msgs.push({severity:'error', detail:'Descrição obrigatória'});
        if (item.status == null)       this.msgs.push({severity:'error', detail:'Status obrigatório'});

        let msg = this.checkExist(item);
        if(msg) {
            this.msgs.push({
                severity: 'error',
                detail: msg
            });
        }

        if (this.msgs.length > 0)
            return;

        this.service.update(item).subscribe((data) => {
            this.msgs.push({
                severity: 'success',
                detail: 'Registro modificado'
            });
        });
        
        this.selectedItem = null;
    }

    checkExist(item: Vehicle){
        if (item.id == null){
            for(let i = 0; i < this.items.length; i++) {
                if(this.items[i].id 
                    && this.items[i].description.trim().toUpperCase() == item.description.trim().toUpperCase()
                    && this.items[i].vehicleBrand.id == item.vehicleBrand.id ) {
                    return 'Não foi possível efetuar o cadastro. Registro já existe';
                }
            }
        } else {
            let quantity = 0;
            for(let i = 0; i < this.items.length; i++) {
                if( this.items[i].description.trim().toUpperCase() == item.description.trim().toUpperCase()
                    && this.items[i].vehicleBrand.id == item.vehicleBrand.id ) {
                    quantity++;
                    if(quantity > 1 ) {
                        return 'Não foi possível efetuar o cadastro. Registro já existe';
                    }
                } 
            }
        }
    }

    cancel(item : Vehicle) {
        this.msgs = [];
        if (this.selectedItem.id == null) {
            this.items.shift();
        }

        if(this.outItem != null && this.outItem.id != null){
            item.description = this.outItem.description;
            item.status = this.outItem.status;
        }

        this.selectedItem = null;
        this.outItem = null;
    }

    edit(item: Vehicle) {
        this.msgs = [];
        this.selectedItem = item;
        this.outItem = this.clone(item);
    }

    clone(i: Vehicle): Vehicle{
        let item = {id: null, vehicleBrand: null, description: null, status:null};
        for(let prop in i){
            item[prop] = i[prop];
        }
        return item;
    }
}